import React from "react";
import { useLocation } from "react-router-dom";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { GetGoalById } from "../../../api/api.service";

import GoalForm from "../AddGoal/GoalForm";
import { hasData } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";

const UpdateGoal = () => {
    const location = useLocation();

    let { useFetch } = useRequestProcessor();

    const id = location?.pathname?.split("/").pop() || 0;

    const {
        data,
        isLoading: isGoalDetailsLoading,
        isFetching
    } = useFetch(
        getKey([MODULE_KEYS.GOAL_DETAILS], { id }),
        async ({ signal }) =>
            await GetGoalById({
                id
            })
    );

    if (isFetching || isGoalDetailsLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return <GoalForm mode="edit" isLoading={false} data={data} />;
};

export default UpdateGoal;
